module.exports = __webpack_public_path__ + "img/Character_Noelle_Thumb.c1e79c8e.png";